/**
 * @typedef {{
 *  children?: React.ReactNode[] | React.ReactNode,
 *  className?: string,
 *  isLoading?: boolean,
 *  onClick?: import('react').MouseEventHandler<HTMLButtonElement>,
 * } & React.ButtonHTMLAttributes<HTMLButtonElement>} LoadingButtonProps
 */

/**
 *
 * @type {React.FC<LoadingButtonProps>}
 */
export const LoadingButton = ({
  children,
  isLoading,
  className,
  disabled,
  onClick,
  ...rest
}) => {
  const handleClick = () => {
    // run parent onClick if there is one.  If it's a form submit button it doesn't necessarily need one
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      type="button"
      className={className}
      disabled={isLoading || disabled}
      onClick={handleClick}
      {...rest}
    >
      {isLoading && (
        <span
          className="spinner-border spinner-border-sm me-1"
          role="status"
          aria-hidden="true"
        />
      )}
      {children}
    </button>
  );
};
